import { render, staticRenderFns } from "./RouterGoBackBtn.vue?vue&type=template&id=5b686e95"
import script from "./RouterGoBackBtn.vue?vue&type=script&lang=js"
export * from "./RouterGoBackBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports